export class BladLogowania extends Error {
  constructor(komunikat: string) {
    super(komunikat);
    this.name = 'BladLogowania';
  }
}

const KOMUNIKAT_AWARII = 'Logowanie chwilowo niedostępne. Spróbuj ponownie za chwilę.';

function komunikatZOdpowiedzi(cialo: unknown): string {
  if (cialo && typeof cialo === 'object') {
    const {error} = cialo as {error?: unknown};
    if (typeof error === 'string' && error.length > 0) return error;
  }
  return KOMUNIKAT_AWARII;
}

async function odczytajCialo(odpowiedz: Response): Promise<unknown> {
  try {
    return await odpowiedz.json();
  } catch {
    return null;
  }
}

export async function pobierzTokenLogowania(
  login: string,
  haslo: string,
  adresFunkcji: string,
  wyslij: typeof fetch = fetch,
): Promise<string> {
  let odpowiedz: Response;
  try {
    odpowiedz = await wyslij(adresFunkcji, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({login, haslo}),
    });
  } catch {
    throw new BladLogowania('Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.');
  }

  const cialo = await odczytajCialo(odpowiedz);
  if (!odpowiedz.ok) {
    throw new BladLogowania(komunikatZOdpowiedzi(cialo));
  }

  const token = cialo && typeof cialo === 'object' ? (cialo as {token?: unknown}).token : undefined;
  if (typeof token !== 'string' || token.length === 0) {
    throw new BladLogowania(KOMUNIKAT_AWARII);
  }
  return token;
}
